import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import cn from 'classnames';
import { BottomSheet, BottomSheetContentLayout, Box, Button, Collapse, Typography } from 'seagull';
import { useLocaleKeys } from '~/i18n';
import styles from './PaymentMethodOption.module.scss';
const PaymentMethodOption = /*#__PURE__*/ forwardRef(function PaymentMethodOption(props, ref) {
    const { text = '', paymentMethodType, parenthesisText, icon, selected, className, disabled, mobileView, sheetTitle, onSheetClose, children, onOptionClick, testId, bottomSheetVariant, bi } = props, rest = _object_without_properties(props, [
        "text",
        "paymentMethodType",
        "parenthesisText",
        "icon",
        "selected",
        "className",
        "disabled",
        "mobileView",
        "sheetTitle",
        "onSheetClose",
        "children",
        "onOptionClick",
        "testId",
        "bottomSheetVariant",
        "bi"
    ]);
    const { t: managePaymentMethodsTexts } = useLocaleKeys('components.managePaymentMethods');
    const paymentMethodTypeTextMap = {
        bankAccount: managePaymentMethodsTexts.bankAccount(),
        creditCard: managePaymentMethodsTexts.card()
    };
    return /*#__PURE__*/ _jsxs(Box, _object_spread_props(_object_spread({
        ref: ref,
        "aria-selected": selected,
        className: cn(styles.optionWrapper, {
            [styles.selected]: selected,
            [styles.mobileView]: mobileView,
            [styles.disabled]: disabled,
            [styles.newUi]: true,
            [styles.optionWrapperHoverable]: !disabled && !selected
        }, className),
        testId: testId
    }, rest), {
        children: [
            /*#__PURE__*/ _jsxs(Button, {
                type: "button",
                className: cn(styles.option, styles.newUiOrder),
                disabled: disabled,
                onClick: onOptionClick,
                testId: testId ? "".concat(testId, "-button") : undefined,
                bi: bi,
                children: [
                    /*#__PURE__*/ _jsx(Box, {
                        className: disabled ? styles.iconDisabled : styles.icon,
                        children: icon
                    }),
                    /*#__PURE__*/ _jsxs(Box, {
                        className: styles.name,
                        children: [
                            /*#__PURE__*/ _jsx(Typography, {
                                as: "span",
                                skin: disabled ? 'secondary' : 'standard',
                                weight: "normal",
                                children: paymentMethodType ? paymentMethodTypeTextMap[paymentMethodType] : text
                            }),
                            parenthesisText && /*#__PURE__*/ _jsxs(Typography, {
                                testId: "payment-method-option-parenthesis",
                                as: "span",
                                variant: "paragraph2",
                                skin: "secondary",
                                className: styles.fee,
                                children: [
                                    ' ',
                                    parenthesisText
                                ]
                            })
                        ]
                    })
                ]
            }),
            mobileView && children && sheetTitle && onSheetClose && /*#__PURE__*/ _jsx(BottomSheet, {
                open: selected,
                onClose: onSheetClose,
                testId: testId ? "".concat(testId, "-sheet") : undefined,
                variant: bottomSheetVariant,
                children: /*#__PURE__*/ _jsx(BottomSheetContentLayout, {
                    header: {
                        title: sheetTitle
                    },
                    contentGutter: "m",
                    children: children
                })
            }),
            mobileView && children && !(sheetTitle && onSheetClose) && /*#__PURE__*/ _jsx(Collapse, {
                in: selected,
                unmountOnExit: true,
                children: /*#__PURE__*/ _jsx(Box, {
                    className: styles.collapsedArea,
                    children: children
                })
            })
        ]
    }));
});
export default PaymentMethodOption;
